import React from 'react'
import Item from './item'

export default function FeaturedContent(){
  if( typeof LOCATION_EXTRAS !== 'object' ){ return null }
  const { featuredContentHeading: heading , featuredContent: items } = LOCATION_EXTRAS
  return heading || items ? (
    <section id="featured-content">
      { heading && <h2>{heading}</h2> }
      {
        Array.isArray( items ) && items.map(
          ( item, index )=>( <Item {...item} key={index} /> )
        )
      }
    </section>
  ) : null
}
